// src/ui/Slots.tsx (T1): tappable time slots (the Next Step card and the thread's proposed times). One can be
// chosen; aria-pressed carries it. They work on white and inside a NavyPanel. `readOnly` lists the same times
// as plain text (someone who sees the times but does not pick them), never as disabled buttons.
// Root class: hb-slots.
import { cx } from "./cx";

/** `short` ("Thu, Sep 24") is the day on a phone, where "Thursday, Sep 24" would wrap in a half-width slot. */
export type Slot = { id: string; day: string; time: string; short?: string };

function Day(props: { s: Slot }) {
  const { s } = props;
  if (!s.short || s.short === s.day) return <span>{s.day}</span>;
  return (
    <span>
      <span class="sl-long">{s.day}</span>
      <span class="sl-short">{s.short}</span>
    </span>
  );
}

export function Slots(props: {
  slots: readonly Slot[];
  chosen?: string | null;
  onChoose?: (id: string | null) => void;
  label?: string;
  disabled?: boolean;
  readOnly?: boolean;
  class?: string;
}) {
  if (props.readOnly) {
    return (
      <ul class={cx("hb-slots", "slots", "is-ro", props.class)} aria-label={props.label ?? "Times"}>
        {props.slots.map((s) => (
          <li key={s.id} class="slot">
            <Day s={s} />
            <b>{s.time}</b>
          </li>
        ))}
      </ul>
    );
  }
  return (
    <div class={cx("hb-slots", "slots", props.class)} role="group" aria-label={props.label ?? "Times"}>
      {props.slots.map((s) => {
        const on = props.chosen === s.id;
        return (
          <button
            key={s.id}
            type="button"
            class="slot"
            aria-pressed={on ? "true" : "false"}
            disabled={props.disabled}
            onClick={() => props.onChoose?.(on ? null : s.id)}
          >
            <Day s={s} />
            <b>{s.time}</b>
          </button>
        );
      })}
    </div>
  );
}
